import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle
} from '@oysterjs/ui/dialog';
import { Button } from '@oysterjs/ui/button';
import { type EmailConfigDraft, type EmailOptions } from '~/api/data/triggers/email-config';
import { type TriggerTargetInput } from '~/api/graphql';
import { EmailIfStep, EmailWhenStep, ThenStep } from '~/components/triggers/trigger-flow-steps';

export const CreationReview = ({
  open,
  onClose,
  config,
  target,
  options
}: {
  open: boolean;
  onClose: () => void;
  config: EmailConfigDraft;
  target: TriggerTargetInput;
  options?: EmailOptions;
}) => {
  const mailboxLabel = (id: string) =>
    options?.accounts.find((account) => account.id === id)?.address.trim() || 'Connected mailbox';
  return (
    <Dialog open={open} onClose={onClose} size="2xl">
      <DialogTitle>Review your trigger</DialogTitle>
      <DialogDescription>
        Check the settings below. Nothing is saved or evaluated here.
      </DialogDescription>
      <DialogBody role="region" aria-label="Trigger draft details" tabIndex={0}>
        <ol className="m-0 list-none rounded-lg border border-neutral-200 p-4 dark:border-neutral-700">
          <EmailWhenStep draft={config} mailboxLabel={mailboxLabel} canReadSetup />
          <EmailIfStep draft={config} options={options} loading={false} />
          <ThenStep target={target} privacy={config.privacy} />
        </ol>
      </DialogBody>
      <DialogActions>
        <Button type="button" color="white" onClick={onClose}>
          Return to editor
        </Button>
      </DialogActions>
    </Dialog>
  );
};
